<template>
  <div>
    <div class="blurred-container">
      <div class="motto">
        <h1>Welcome to Acts!</h1>
        <h4 v-if="!hasTenTimelyReports && isOneOfTheseRoles(['student'])">
          {{ timelyReports }} / 10 Timely Reports, {{ 10 - timelyReports }} to go!
          <i class="el-icon-question timely-report-info" @click="showSwal('timely-info')" />
        </h4>
        <h4 v-if="hasTenTimelyReports && isOneOfTheseRoles(['student'])">
          You got {{ timelyReports }} / 10 Timely Reports! Click this
          <a class="prize-link" :href="prizeLink" target="_blank">link</a> to claim a prize.
        </h4>
        <div id="timely-reports-container" />
      </div>
      <div
        class="gf-button-wrapper"
        v-if="showGradPageLink && isOneOfTheseRoles(['td','missionary', 'rd', 'ad']) && !isOneOfTheseRoles(['admin'])"
        v-loading="loading"
        element-loading-text="Sending..."
        element-loading-spinner="el-icon-loading"
      >
        <badge slot="header" type="success">
          <i class="nc-icon nc-bulb-63" /> Graduate Page
        </badge>
        <p
          class="
          text-center
          button-text"
          v-if="showGradPageLink && isOneOfTheseRoles(['td','missionary'])"
        >
          Your campus's Graduate Page is ready for you to complete.<br>
          This feature will NOT work on mobile view.
          <p-button
            type="success"
            class="td-button"
            @click="goToGradForms()"
          >
            Go to my Graduate Page
          </p-button>
        </p>
        <!-- RD's/AD's need a different button -->
        <p
          class="
          text-center
          button-text"
          v-if="showGradPageLink && isOneOfTheseRoles(['rd', 'ad'])"
        >
          Your campuses have started to submit graduation info for seniors.
          Click below to check on the status of your campuses.<br>
          This feature will NOT work on mobile view.
          <p-button
            type="success"
            class="td-button"
            @click="goToRegionalGradForms()"
          >
            Check my campuses
          </p-button>
        </p>
      </div>
      <!-- <div
        class="qr-button-wrapper"
        v-if="isOneOfTheseRoles(['td','missionary']) && !isOneOfTheseRoles(['admin'])"
        v-loading="loading"
        element-loading-text="Sending..."
        element-loading-spinner="el-icon-loading"
      >
        <badge slot="header" type="info">
          <i class="fa fa-qrcode" /> Campus Outreach
        </badge>
        <p
          class="
          text-center
          button-text"
        >
          Download campus QR code for student interest form collection<br>
          <p-button
            round
            icon
            type="info"
            class="td-button"
            @click="generateQR()"
          >
            <i class="fa fa-arrow-down" />
          </p-button>
        </p>
      </div> -->
      <div
        class="td-button-wrapper"
        v-if="isOneOfTheseRoles(['td'])"
        v-loading="loading"
        element-loading-text="Sending..."
        element-loading-spinner="el-icon-loading"
      >
        <badge slot="header" type="danger">
          <i class="nc-icon nc-bulb-63" /> Vacation Dates
        </badge>
        <p
          v-if="isOnVacation"
          class="
          text-center
          button-text"
        >
          <b>Your campus is currently on vacation until {{ isOnVacation }}.</b>
        </p>
        <p
          v-if="!futureVacationDates"
          class="
          text-center
          button-text"
        >
          Would you like to set a vacation date for your campus
          so your bible study attendances aren't generated?<br>
          <p-button
            type="danger"
            round
            icon
            class="td-button"
            @click="handleSelectVacationDates(-1)"
          >
            <i class="nc-icon nc-simple-add" />
          </p-button>
        </p>
        <p
          v-if="futureVacationDates"
          class="
          text-center
          button-text"
        >
          Would you like to set a new vacation date?<br>
          <p-button
            type="danger"
            round
            icon
            class="td-button"
            @click="handleSelectVacationDates(-1)"
          >
            <i class="nc-icon nc-simple-add" />
          </p-button>
        </p>
        <p
          class="button-text text-center"
          v-for="(vacationDate, index) in futureVacationDates"
          :key="vacationDate.id"
          style="font-size: 1em; line-height: 1;"
        >
          {{ vacationDate.name }}: &nbsp;&nbsp;{{ vacationDate.range_readable }}&nbsp;
          <i
            class="el-icon-edit icon-btn"
            @click="handleSelectVacationDates(index)"
          /><br>
        </p>
      </div>
      <div class="img-src" style="background-image: url(/static/img/background/background-cropped-5.jpg)" />
    </div>
    <div v-if="isOneOfTheseRoles(['guest'])">
      <div class="main-container">
        <h4 style="text-align:center;">
          This is a tool that helps our missionaries plan bible studies.
          We also have some other resources for students. Check out the meditations!
          If you have any problems, please email support@focus.org.
        </h4>
      </div>
    </div>
    <div v-else class="main-container">
      <div class="container-fluid tim-container">
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-12">
            <card card-body-classes="text-center">
              <img
                src="../../public/static/img/background/prepare-bible-study-cropped-2.jpg"
                alt=""
                height="150"
                class="feature-img"
              >
              <div class="card-footer feature-footer">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="footer-title">
                      Prepare for Your Bible Study
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <p-button
                      type="warning"
                      icon
                      round
                      @click="goToPlanBibleStudy()"
                    >
                      <i class="nc-icon nc-ruler-pencil" />
                    </p-button>
                  </div>
                </div>
              </div>
            </card>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12">
            <card card-body-classes="text-center">
              <img
                src="../../public/static/img/background/ignatian-meditations.jpg"
                alt=""
                height="150"
                class="feature-img"
              >
              <div class="card-footer feature-footer">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="footer-title">
                      Read Scriptural Meditations
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <p-button
                      type="danger"
                      icon
                      round
                      @click="goToMeditations()"
                    >
                      <i class="nc-icon nc-button-play" />
                    </p-button>
                  </div>
                </div>
              </div>
            </card>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12">
            <card card-body-classes="text-center">
              <img
                src="../../public/static/img/background/seek.jpg"
                alt=""
                height="150"
                class="feature-img"
              >
              <div class="card-footer feature-footer">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="footer-title">
                      Register for SEEK!
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <a :href="seekLink" target="_blank">
                      <p-button
                        type="success"
                        icon
                        round
                      >
                        <i class="nc-icon nc-single-02" />
                      </p-button>
                    </a>
                  </div>
                </div>
              </div>
            </card>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12">
            <card card-body-classes="text-center">
              <img
                src="../../public/static/img/background/text-to-report.jpg"
                alt=""
                height="150"
                class="feature-img"
              >
              <div class="card-footer feature-footer">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="footer-title">
                      Get a Text to Report Study
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <p-button
                      type="info"
                      icon
                      round
                      @click="goToMyPerson()"
                    >
                      <i class="nc-icon nc-mobile" />
                    </p-button>
                  </div>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </div>
    <VacationDatesModal
      :show="modals.openVDmodal"
      :active-form="activeForm"
      @close="modals.openVDmodal = !modals.openVDmodal; activeForm = -1"
      ref="childVDModalComponent"
    />
  </div>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import swal from 'sweetalert2';
import { Badge } from 'src/components/UIComponents';
import apiService from '../repositories/apiService';
import VacationDatesModal from '../components/VacationDates/Modal.vue';
import { RepositoryFactory } from '../repositories/repositoryFactory';

const LocationsRepository = RepositoryFactory.get('locations');
const PeopleRepository = RepositoryFactory.get('people');
const GraduationRecordsRepository = RepositoryFactory.get('graduationRecords');

export default {
    name: 'Main',
    components: {
        VacationDatesModal,
        Badge
    },
    data() {
        return {
            loading: false,
            modals: {
                openVDmodal: false
            },
            activeForm: -1,
            timelyReports: null,
            prizeLink: process.env.VUE_APP_PRIZE_LINK,
            seekLink: 'https://seek.focus.org/',
            showGradPageLink: false,
            isOnVacation: false
        };
    },
    computed: {
        ...mapGetters({
            futureVacationDates: 'VacationDates/futureVacationDates',
            role: 'role'
        }),
        hasTenTimelyReports() { return this.timelyReports >= 10; }
    },
    methods: {
        goToGradForms() {
            this.$router.push({ name: 'GraduationRecords' });
        },
        goToRegionalGradForms() {
            this.$router.push({ name: 'RegionalGraduationRecords' });
        },
        getVDFromIndex(index) {
            return this.futureVacationDates[index];
        },
        handleSend() {
            this.loading = true;
            return new Promise((resolve, reject) => {
                apiService
                    .post('/disciple/remindCampusLogin')
                    .then((response) => {
                        resolve();
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.error = error.response.data.message;
                        this.loading = false;
                    });
            });
        },
        handleSelectVacationDates(index) {
            if (index >= 0) {
                const editThis = this.getVDFromIndex(index);
                this.$refs.childVDModalComponent.editVD.id = editThis.id;
                this.$refs.childVDModalComponent.editVD.name = editThis.name;
                this.$refs.childVDModalComponent.editVD.startDate = new Date(editThis.start_date);
                this.$refs.childVDModalComponent.editVD.endDate = new Date(editThis.end_date);
                this.activeForm = -1;
            } else {
                this.activeForm = 0;
            }
            this.modals.openVDmodal = !this.modals.openVDmodal;
        },
        goToPlanBibleStudy() {
            this.$router.push({ name: 'BibleStudyPlan' });
        },
        goToMeditations() {
            this.$router.push({ name: 'Meditation' });
        },
        showSwal(type) {
            if (type === 'basic') {
                swal({
                    title: 'Feature coming soon!',
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill'
                }).catch(swal.noop);
            } else if (type === 'timely-info') {
                swal({
                    title: 'Get a prize for submitting attendance on time!',
                    text: `For each week that you hold bible study (meaning you don't cancel) and 
                    submit your attendance within 7 days of leading your study, you will get 1 "Timely Report".
                    If you log 10 timely reports in a single semester, 
                    you will receive a prize in your email inbox at the end of the semester!
                    Note: If you lead two bible studies, you can only get 1 Timely Report per week. 
                    Only attendances submitted from September 1 to December 15 and January 15 to April 30 
                    count towards the goal. If you do not lead a bible study, unfortunately, you cannot qualify
                    for the prize.`,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill'
                }).catch(swal.noop);
            }
        },
        goToMyPerson() {
            return new Promise((resolve, reject) => {
                apiService
                    .get('/people/user')
                    .then((response) => {
                        this.$router.push({ name: 'PersonEdit', params: { id: response.data.personId } });
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.error = error.response.data.message;
                        this.loading = false;
                    });
            });
        },
        generateQR() {
            LocationsRepository.generateQrForRegistration()
                .then((response) => {
                    // Download file from browser
                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(blob);
                    const anchor = document.createElement('a');
                    anchor.download = 'qr.pdf';
                    anchor.href = url;
                    anchor.click();
                })
                .catch((error) => {
                    this.$message(error.response.data.message);
                });
        },
        getTimelyReports() {
            PeopleRepository.getTimelyReports()
                .then((response) => {
                    this.timelyReports = response.data;
                    this.showTimelyReports();
                })
                .catch((error) => {
                    this.error = error.response.data.message;
                    this.$message(error.response.data.message);
                });
        },
        showTimelyReports() {
            // instantiate div to populate with check marks
            const checksContainer = document.getElementById('timely-reports-container');
            // they only need to 10 to win so anything above that, just set to 10
            if (this.timelyReports >= 10) {
                this.timelyReports = 10;
            }
            // create the number of filled checks with a for loop
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < this.timelyReports; i++) {
                // create a circle check
                const circleCheck = document.createElement('i');
                // add the class name to give it appropriate styling
                circleCheck.className = 'el-icon-success timely-check';
                // append it as a child to the div that will hold the checks
                checksContainer.appendChild(circleCheck);
            }
            // instantiante the number of empty checks
            const timelyReportsToGo = 10 - this.timelyReports;
            // do the same thing as filled checks with the empty checks
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < timelyReportsToGo; i++) {
                const circleCheck = document.createElement('i');
                circleCheck.className = 'el-icon-circle-check timely-check-empty';
                checksContainer.appendChild(circleCheck);
            }
        },
        getGradFormStatus() {
            const today = new Date(Date.now());
            const year = today.getFullYear();
            // 3-27-25 pushing this back to give us more time to sync up with alumni
            // const april = new Date(`04/01/${year}`);
            const april = new Date(`04/04/${year}`);
            const june = new Date(`06/01/${year}`);

            // show automatically if between April 1st and Jun 1st
            if (today >= april && today < june) {
                this.showGradPageLink = true;
                // no need to do anything else
                return;
            }

            const march = new Date(`03/01/${year}`);

            // if between March 1st and April 1st, check to see if grad forms exist
            if (today >= march && today < april) {
                GraduationRecordsRepository
                    .getGraduationRecordsIsGenerated().then((response) => {
                        if (response.data === true) {
                            this.showGradPageLink = true;
                        }
                    }).catch((error) => {
                        this.$store.commit('setError', error);
                        this.loading = false;
                        this.error = error.response.data.message;
                        this.$message(this.error);
                    });
            }
        },
        getIsOnVacation() {
            apiService
                .get('/location/is-on-vacation')
                .then((response) => {
                    this.isOnVacation = response.data;
                })
                .catch((error) => {
                    this.error = error;
                });
        }
    },
    watch: {
        role() {
            if (this.isOneOfTheseRoles(['td']) && !this.isOneOfTheseRoles(['admin'])) {
                this.$store.dispatch('VacationDates/getVacationDates');
                this.getIsOnVacation();
            }
            // due to timing issues, this must be run as a watcher
            if (this.isOneOfTheseRoles(['student']) && !this.isOneOfTheseRoles(['admin'])) {
                this.getTimelyReports();
            }
        }
    },
    created() {
        this.getGradFormStatus();
        if (this.$store.state.role != null) {
            if (this.isOneOfTheseRoles(['td'])) {
                this.getIsOnVacation();
            }
        }
    },
    mounted() {
        if (this.isOneOfTheseRoles(['student']) && !this.isOneOfTheseRoles(['admin'])) {
            this.getTimelyReports();
        }
    }
};
</script>
<style>
.blurred-container{
  position:relative;
  width:100%;
  height:340px;
  top:0;
  left:0;
}
.blurred-container > .img-src{
    position:fixed;
    width:110%;
    height:540px;
    background-repeat:no-repeat;
    background-size:cover;
    background-position: center center;
    margin-left: -30px;
    margin-top: -30px;
}
.blurred-container .motto{
    color: #FFFFFF;
    z-index: 3;
    display: block;
    margin: 0 auto;
    position: relative;
    height: 0;
}
.tim-row{
    margin-bottom: 20px;
}
.tim-title{
    margin-top: 30px;
    margin-bottom: 15px;
}
.main-container {
    background-color: #f4f3ef;
    position: relative;
    margin-left: -30px;
    margin-right: -30px;
}
.td-button-wrapper {
  background-color: rgba(28, 45, 69, 0.7);
  padding-right: 10px;
  padding-left: 10px;
  padding-top: 10px;
  z-index: 3;
  position: absolute;
  bottom: 0;
  right: 0;
  margin-bottom: 5px;
}
.gf-button-wrapper {
  background-color: rgba(28, 45, 69, 0.7);
  padding-right: 10px;
  padding-left: 10px;
  padding-top: 10px;
  z-index: 3;
  position: absolute;
  top: 0;
  left: 0;
}
.qr-button-wrapper {
  background-color: rgba(28, 45, 69, 0.7);
  padding-right: 10px;
  padding-left: 10px;
  padding-top: 10px;
  z-index: 3;
  position: absolute;
  bottom: 0;
  left: 0;
  margin-bottom: 5px;
}
.button-text {
  color: #ffffff;
  margin-bottom: 10px;
  margin-top: 10px;
}
.feature-img {
  object-fit: cover;
}
.feature-card {
  padding-top: 10px;
}
.feature-footer {
  padding-top: 5px;
  padding-left: 0px;
  padding-right: 0px;
  display: block !important;
}
.timely-check {
  font-size: 32px;
}
.timely-check-empty {
  font-size: 32px;
  opacity: 0.4;
}
.prize-link {
  color: #FFFFFF;
  text-decoration: underline;
  font-weight: 1000;
}
.timely-report-info {
  color: #66b1ff;
  border-radius: 50%;
}
.timely-report-info:hover {
  color: #FFFFFF;
}
@media only screen and (min-width: 1367px) {
  .blurred-container {
    height: 500px;
  }
  .td-button-wrapper, .gf-button-wrapper, .qr-button-wrapper {
    width: 500px;
  }
  .gf-button-wrapper {
    margin-top: 5rem;
  }
  .motto > h1 {
    font-size: 5em;
  }
  .button-text, .footer-title {
    font-size: 1.25em;
  }
}

@media only screen and (min-width: 1921px) {
  .feature-img {
    height: 350px;
  }
}
@media only screen and (min-width: 1657px) and (max-width: 1920px) {
    .feature-img {
      height: 250px;
    }
}
@media only screen and (min-width: 473px) and (max-width: 1367px) {
    .td-button-wrapper, .gf-button-wrapper, .qr-button-wrapper {
      width: 400px;
    }
    .gf-button-wrapper {
      margin-top: 3.5rem;
    }
}
@media only screen and (max-width: 473px) {
  .blurred-container {
    height: 450px;
  }
  .gf-button-wrapper {
    margin-top: 7rem;
  }
  .qr-button-wrapper {
      display: none;
    }
}
</style>
